// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2ZBQY","loaderOuter":"PageOverlayLoader_loaderOuter__2p6Sz"};